function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["a11y", "children", "className", "color", "fromLinkButton", "id", "isDecorative", "isTextFirst", "isVisible", "placeholder", "size", "sprite", "textAlignment"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { isValidElement, lazy, Suspense } from 'react';
import { createEnum, ValidPropTypes, makeErrorBoundComponent } from '@els/els-react--utils';
import classnames from 'classnames';
import PT from 'prop-types';
var __variableDynamicImportRuntimeHelper = function __variableDynamicImportRuntimeHelper(glob, path, segs) {
  var v = glob[path];
  if (v) {
    return typeof v === "function" ? v() : Promise.resolve(v);
  }
  return new Promise(function (_, reject) {
    (typeof queueMicrotask === "function" ? queueMicrotask : setTimeout)(reject.bind(null, new Error("Unknown variable dynamic import: " + path + (path.split("/").length !== segs ? ". Note that variables only represent file names one level deep." : ""))));
  });
};
var SpriteSizes = createEnum(['xxs', 'xs', 's', 'm', 'ml', 'l', 'xl', 'stretch']);
var IconColors = createEnum(['default', 'primary', 'secondary', 'positive', 'negative']);
var FontAlignments = createEnum(['baseline', 'bottom', 'inherit', 'initial', 'middle', 'offset', 'sub', 'top']);

// This file is programmatically generated. See https://github.com/elsevier-health/health-leyden/blob/main/docs/adding-an-icon.md for information on adding icons

// eslint-disable-next-line import/prefer-default-export
var SpriteNames = createEnum(['AI', 'Activity', 'AddCircle', 'AddDocument', 'AddNewComment', 'AddSolidCircle', 'AddToCart', 'AddUser', 'AddUsers', 'Airplay', 'Alarm', 'AlarmClock', 'Alert', 'AlertDrug', 'AlertOutlineCircle', 'AlertOutlineSquare', 'AlertQsen', 'AlertSafety', 'AlertSolidCircle', 'AlertSolidSquare', 'AlertTornado', 'AlertUnexpectedError', 'AlertUnsupportedBrowser', 'Alignment', 'AppStore', 'AppSwitcher', 'Apple', 'ApproveDocument', 'Archive', 'ArrowDown', 'ArrowHook', 'ArrowLeft', 'ArrowRight', 'ArrowStatUp', 'ArrowUp', 'ArticleInPress', 'AssessmentActivity', 'Assignments', 'AudioSlides', 'Backspace', 'Bicycle', 'Binocular', 'Blueprint', 'Book', 'Bookmark', 'BookmarkOff', 'BookmarkOn', 'Books', 'Box', 'BubbleChart', 'Bullseye', 'BusinessMan', 'BusinessPhone', 'Calculator', 'Calendar', 'CalendarEmpty', 'CalendarNotAvailable', 'CallCenter', 'Camera', 'CameraFilm', 'CardCollapse', 'CardExpand', 'Carrot', 'CaseStudy', 'Caution', 'Cell', 'CellObject', 'CellProcess', 'ChargeBattery', 'CheckClipboard', 'Checkmark', 'ChevronDown', 'ChevronLeft', 'ChevronRight', 'ChevronUp', 'Circle', 'CircleMapView', 'Citatonbench', 'ClinicalTrial', 'Clock', 'Clockwise', 'Close', 'CloseQuotes', 'Cloud', 'CloudDownload', 'CloudUpload', 'Clouds', 'Coffee', 'CoffeeBean', 'CoffeeNotAvailable', 'Colander', 'Collapse', 'ColumnLeft', 'ColumnMiddle', 'ColumnRight', 'Columns', 'Comb', 'Comment', 'CompareSavedVersions', 'Compass', 'Computer', 'ComputerMouse', 'ConfirmationOutlineCircle', 'ConfirmationSolidCircle', 'Connection', 'Contract', 'Countries', 'CountriesEdit', 'CountryEdit', 'CoupleOfPeople', 'CreateBibliography', 'CreditCard', 'Credits', 'Crop', 'Cursor', 'CycleQuestion', 'CycleSquare', 'Database', 'DeleteDocument', 'Directions', 'Discussion', 'Disease', 'Doc', 'DocFile', 'DocumentCheck', 'DocumentChecked', 'DocumentCsv', 'DocumentNew', 'DocumentNotAvailable', 'DownLeft', 'DownRight', 'Download', 'Drag', 'DrawStructureNew', 'Drop', 'DuplicateDocument', 'DvdPlayer', 'Ebook', 'EbookReading', 'Edit', 'EducationHistory', 'Eject', 'Ellipsis', 'EllipsisOpen', 'Elsevier', 'Email', 'EmpoweringKnowledge', 'EmptyCart', 'EmtreeTaxonomyBrowser', 'Epub', 'Eraser', 'Exam', 'ExeFile', 'Expand', 'Expand2', 'ExportDocument', 'ExportProfileOrcid', 'EyeCare', 'EyeNotVisible', 'EyeVisible', 'Facebook', 'FailedOutlineCircle', 'FailedOutlineSquare', 'FailedSolidCircle', 'FailedSolidSquare', 'FastForward', 'Fax', 'FeedbackExcited', 'FeedbackHappy', 'FeedbackMeh', 'FeedbackSad', 'FemaleFace', 'File', 'Filter', 'FingerPointUp', 'Flag', 'FlipTile', 'Flowchart', 'Folder', 'FolderIn', 'FolderOut', 'FolderSolid', 'Forbidden', 'Fork', 'FountainPen', 'FullyCharged', 'FunctionalClass', 'GifFile', 'Globe', 'GooglePlay', 'Grid', 'GroupOfPeople', 'GroupOfResearchers', 'Hand', 'HardDrive', 'Heart', 'HeartSolid', 'HelpOutlineCircle', 'HelpSolidCircle', 'HighBattery', 'Highlight', 'Home', 'HomeInstitution', 'Hospital', 'Hot', 'HotTea', 'HyHart', 'Idea', 'InProgress', 'Inbox', 'InformationOutlineCircle', 'InformationOutlineSquare', 'InformationSolidCircle', 'InformationSolidSquare', 'Instagram', 'Institution', 'InstitutionEdit', 'InstitutionRanking', 'Institutions', 'InstitutionsEdit', 'InteractiveCaseInsights', 'Journal', 'JpgFile', 'JumpToFirst', 'JumpToLast', 'Key', 'LabSkills', 'Label', 'Laptop', 'Layers', 'Leaf', 'Lesson', 'LineCharts', 'Link', 'Linkedin', 'List', 'Loading', 'Location', 'Lock', 'LogIn', 'LogOut', 'LowBattery', 'MaleFace', 'Man', 'MapLocation', 'Mastodon', 'MatrixView', 'MeasuringCup', 'MedicalCross', 'MediumBattery', 'Menu', 'Merge', 'MetabolizingEnzymesTransporters', 'Microphone', 'Microwave', 'Minus', 'MinusCircle', 'MinusSolidCircle', 'MobiFile', 'MobilePhone', 'Mobipocket', 'MolecularModels', 'Moon', 'Move', 'MovingBox', 'MovingBoxDown', 'MovingBoxUp', 'Mp3File', 'MultipleLayers', 'MusicalNote', 'NavCollapse', 'NavExpand', 'Navigate', 'Needle', 'Neuroimagery', 'NeutralFace', 'New', 'Newspaper', 'NoEditing', 'NoSmoking', 'NonCodingRNA', 'NonSolus', 'NotStarted', 'Note', 'Notebook', 'NotificationsDisabled', 'OfficeBuilding', 'OpenBook', 'OpenFolder', 'OpenHandRight', 'OpenQuotes', 'Orange', 'Outbox', 'Paperclip', 'Pathogen', 'PauseHollow', 'PauseSolid', 'PdfAlternative', 'PdfFile', 'Performance', 'PerformanceNotAvailable', 'Person', 'Pharmacokinetic', 'Phone', 'PhoneDisabled', 'Picture', 'PieChart', 'Pill', 'Pin', 'Pixel', 'PlayHollow', 'PlaySolid', 'PlayVideo', 'Plus', 'PngFile', 'PointingLeftUp', 'PointingRight', 'Ppt2', 'PptFile', 'Printer', 'Protein', 'ProteinKinase', 'ProteinLigand', 'ProteinPhotophosphatase', 'ProteinReceptor', 'ProteinTranscriptionFactor', 'ProteinTransporter', 'ProteinVariations', 'PublicationSet', 'PublicationSets', 'Radiology', 'Rainbow', 'Rainbow2', 'RarFile', 'Rationale', 'Record', 'Redo', 'RemoveDocument', 'Repeat', 'ResearchArea', 'ResearchAreaEdit', 'ResearchAreas', 'ResearchAreasEdit', 'Researcher', 'ResearcherProfileNeedsAction', 'ResearcherProfileUpdated', 'Retweet', 'Rewind', 'Rotate', 'Rows', 'Ruler', 'RulerRotate', 'SaveFile', 'ScaleDown', 'ScaleUp', 'Schedule', 'Search', 'SearchDocument', 'SecondaryResult', 'SelectionPanelAdd', 'SelectionPanelRemove', 'Send', 'Settings', 'Share', 'Share2', 'ShoppingCart', 'Shuffle', 'SimulationNursing', 'SkillsChecklist', 'SkipBack', 'SkipForward', 'Smartphone', 'SortAsc', 'SortDefault', 'SortDesc', 'SoundHigh', 'SoundLow', 'SoundMedium', 'SoundOff', 'Spinner', 'Standard', 'Star', 'StarSolid', 'Statistics', 'Stats', 'Stethoscope', 'Stop', 'StopGesture', 'Stopwatch', 'Strawberry', 'Structure', 'Study', 'SubjectNameSubcategory', 'Suitcase', 'Sun', 'Syllabus', 'Sync', 'Tables', 'Tablet', 'TeddyBear', 'Temperature', 'TextFile', 'ThumbsDown', 'ThumbsUp', 'Tornado', 'Trash', 'Twitter', 'TxtFile', 'Undo', 'Unlink', 'Unlock', 'UpLeft', 'UpRight', 'Upload', 'UpwardsLineChart', 'Usb', 'Vector', 'VideoCamera', 'ViewAuthorDocuments', 'VirtualMicroscope', 'Virus', 'Warning', 'Webcam', 'Wheelchair', 'Woman', 'Wrench', 'Writing', 'X', 'XAxis', 'XlsFile', 'YAxis', 'YouTube', 'ZipFile', 'ZoomIn', 'ZoomOut']);
var bool = PT.bool,
  node = PT.node,
  oneOf = PT.oneOf,
  shape = PT.shape,
  string = PT.string;
var lazySvgs = {};
var Icon = function Icon(_ref) {
  var _ref$a11y = _ref.a11y,
    description = _ref$a11y.description,
    name = _ref$a11y.name,
    children = _ref.children,
    className = _ref.className,
    color = _ref.color,
    fromLinkButton = _ref.fromLinkButton,
    id = _ref.id,
    isDecorative = _ref.isDecorative,
    isTextFirst = _ref.isTextFirst,
    isVisible = _ref.isVisible,
    placeholder = _ref.placeholder,
    size = _ref.size,
    sprite = _ref.sprite,
    textAlignment = _ref.textAlignment,
    iconProps = _objectWithoutProperties(_ref, _excluded);
  if (!sprite) {
    throw new TypeError("The sprite property of an icon must be defined.");
  }
  if (!Object.values(SpriteNames).includes(sprite)) {
    throw new TypeError("The sprite '".concat(sprite, "' is not a currently supported icon. Make sure the icon was added to the /constants/sprite-names.js file"));
  }
  if (!isDecorative && !children && !name) {
    throw new TypeError("Non-decorative Icon must include child content for accessibility.");
  }
  if (!isDecorative && placeholder === "") {
    throw new TypeError("Non-decorative Icon cannot have an empty placeholder.");
  }
  var classes = classnames("icon", "o-els-icon-svg", {
    "o-els-icon-svg--3o4": size === SpriteSizes.XXS,
    "o-els-icon-svg--1x": size === SpriteSizes.XS,
    "o-els-icon-svg--1x1o2": size === SpriteSizes.S,
    "o-els-icon-svg--2x": size === SpriteSizes.M,
    "o-els-icon-svg--3x": size === SpriteSizes.ML,
    "o-els-icon-svg--4x": size === SpriteSizes.L,
    "o-els-icon-svg--5x": size === SpriteSizes.XL,
    "o-els-icon-svg--baseline": textAlignment === FontAlignments.BASELINE,
    "o-els-icon-svg--bottom": textAlignment === FontAlignments.BOTTOM,
    "o-els-icon-svg--inherit": textAlignment === FontAlignments.INHERIT,
    "o-els-icon-svg--initial": textAlignment === FontAlignments.INITIAL,
    "o-els-icon-svg--middle": textAlignment === FontAlignments.MIDDLE,
    "o-els-icon-svg--middle o-els-icon-svg--font-offset": textAlignment === FontAlignments.OFFSET,
    "o-els-icon-svg--sub": textAlignment === FontAlignments.SUB,
    "o-els-icon-svg--top": textAlignment === FontAlignments.TOP,
    // Applied to the SVG only as text color should be inherited from the surrounding content
    "u-els-color-primary": color === IconColors.PRIMARY,
    "u-els-color-secondary": color === IconColors.SECONDARY,
    "u-els-color-confirm": color === IconColors.POSITIVE,
    "u-els-color-warn": color === IconColors.NEGATIVE
  });
  var wrapperClasses = classnames(className, "icon__wrapper");
  var textClasses = classnames("icon__text", {
    "u-els-margin-left-1o2": !isTextFirst,
    "u-els-margin-right-1o2": isTextFirst,
    "u-els-hide-visually": !isVisible,
    "c-els-link__text": fromLinkButton
  });
  var spriteId = id ? "".concat(id, "-sprite") : null;
  var nameId = id ? "".concat(id, "-name") : null;
  var labelId = id ? "".concat(id, "-label") : null;
  var childrenIsString = children && !isValidElement(children);
  if (!lazySvgs[sprite]) {
    lazySvgs[sprite] = lazy(function () {
      return __variableDynamicImportRuntimeHelper(/* #__PURE__ */Object.assign({
        "./svgs/icons/AI.jsx": function svgsIconsAIJsx() {
          return import('./AI-CuvThtBk.js');
        },
        "./svgs/icons/Activity.jsx": function svgsIconsActivityJsx() {
          return import('./Activity-Gjfx6Oiq.js');
        },
        "./svgs/icons/AddCircle.jsx": function svgsIconsAddCircleJsx() {
          return import('./AddCircle-BabjJrRv.js');
        },
        "./svgs/icons/AddCircleSolid.jsx": function svgsIconsAddCircleSolidJsx() {
          return import('./AddCircleSolid-CEiG_NZg.js');
        },
        "./svgs/icons/AddDocument.jsx": function svgsIconsAddDocumentJsx() {
          return import('./AddDocument-C-Q_uObL.js');
        },
        "./svgs/icons/AddNewComment.jsx": function svgsIconsAddNewCommentJsx() {
          return import('./AddNewComment-4MoyMYAV.js');
        },
        "./svgs/icons/AddSolidCircle.jsx": function svgsIconsAddSolidCircleJsx() {
          return import('./AddSolidCircle-rW20D8xn.js');
        },
        "./svgs/icons/AddToCart.jsx": function svgsIconsAddToCartJsx() {
          return import('./AddToCart-2P1GtE5e.js');
        },
        "./svgs/icons/AddUser.jsx": function svgsIconsAddUserJsx() {
          return import('./AddUser-2DkUobui.js');
        },
        "./svgs/icons/AddUsers.jsx": function svgsIconsAddUsersJsx() {
          return import('./AddUsers-PI-V1mLi.js');
        },
        "./svgs/icons/Airplay.jsx": function svgsIconsAirplayJsx() {
          return import('./Airplay-DuCHrzhz.js');
        },
        "./svgs/icons/Alarm.jsx": function svgsIconsAlarmJsx() {
          return import('./Alarm-BS-cEWut.js');
        },
        "./svgs/icons/AlarmClock.jsx": function svgsIconsAlarmClockJsx() {
          return import('./AlarmClock-eZL6krkw.js');
        },
        "./svgs/icons/Alert.jsx": function svgsIconsAlertJsx() {
          return import('./Alert-DFLLdZ9p.js');
        },
        "./svgs/icons/AlertDrug.jsx": function svgsIconsAlertDrugJsx() {
          return import('./AlertDrug-DZw1K0BU.js');
        },
        "./svgs/icons/AlertOutlineCircle.jsx": function svgsIconsAlertOutlineCircleJsx() {
          return import('./AlertOutlineCircle-CXfn_1vD.js');
        },
        "./svgs/icons/AlertOutlineSquare.jsx": function svgsIconsAlertOutlineSquareJsx() {
          return import('./AlertOutlineSquare-DH6sfnmK.js');
        },
        "./svgs/icons/AlertQsen.jsx": function svgsIconsAlertQsenJsx() {
          return import('./AlertQsen-Bb7CejRv.js');
        },
        "./svgs/icons/AlertSafety.jsx": function svgsIconsAlertSafetyJsx() {
          return import('./AlertSafety-gip_TEaC.js');
        },
        "./svgs/icons/AlertSolidCircle.jsx": function svgsIconsAlertSolidCircleJsx() {
          return import('./AlertSolidCircle-Tv6gzZPX.js');
        },
        "./svgs/icons/AlertSolidSquare.jsx": function svgsIconsAlertSolidSquareJsx() {
          return import('./AlertSolidSquare-DhjrAYUa.js');
        },
        "./svgs/icons/AlertTornado.jsx": function svgsIconsAlertTornadoJsx() {
          return import('./AlertTornado-BHNecOqs.js');
        },
        "./svgs/icons/AlertUnexpectedError.jsx": function svgsIconsAlertUnexpectedErrorJsx() {
          return import('./AlertUnexpectedError-BaubjL3n.js');
        },
        "./svgs/icons/AlertUnsupportedBrowser.jsx": function svgsIconsAlertUnsupportedBrowserJsx() {
          return import('./AlertUnsupportedBrowser-Cf7SWNS1.js');
        },
        "./svgs/icons/Alignment.jsx": function svgsIconsAlignmentJsx() {
          return import('./Alignment-g3ZAUcM4.js');
        },
        "./svgs/icons/AppStore.jsx": function svgsIconsAppStoreJsx() {
          return import('./AppStore-D7NY5JsC.js');
        },
        "./svgs/icons/AppSwitcher.jsx": function svgsIconsAppSwitcherJsx() {
          return import('./AppSwitcher-HwrGaT1g.js');
        },
        "./svgs/icons/Apple.jsx": function svgsIconsAppleJsx() {
          return import('./Apple-0obJh-Bj.js');
        },
        "./svgs/icons/ApproveDocument.jsx": function svgsIconsApproveDocumentJsx() {
          return import('./ApproveDocument-CQXFXwGd.js');
        },
        "./svgs/icons/Archive.jsx": function svgsIconsArchiveJsx() {
          return import('./Archive-BC4vtT7R.js');
        },
        "./svgs/icons/ArrowDown.jsx": function svgsIconsArrowDownJsx() {
          return import('./ArrowDown-DSk5V4V_.js');
        },
        "./svgs/icons/ArrowHook.jsx": function svgsIconsArrowHookJsx() {
          return import('./ArrowHook-BvUnVtBC.js');
        },
        "./svgs/icons/ArrowLeft.jsx": function svgsIconsArrowLeftJsx() {
          return import('./ArrowLeft-BKB6n9iT.js');
        },
        "./svgs/icons/ArrowRight.jsx": function svgsIconsArrowRightJsx() {
          return import('./ArrowRight-BShqSlN_.js');
        },
        "./svgs/icons/ArrowStatUp.jsx": function svgsIconsArrowStatUpJsx() {
          return import('./ArrowStatUp-sbgIyD0F.js');
        },
        "./svgs/icons/ArrowUp.jsx": function svgsIconsArrowUpJsx() {
          return import('./ArrowUp-DqbATl8y.js');
        },
        "./svgs/icons/ArticleInPress.jsx": function svgsIconsArticleInPressJsx() {
          return import('./ArticleInPress-ANqXA5ZM.js');
        },
        "./svgs/icons/AssessmentActivity.jsx": function svgsIconsAssessmentActivityJsx() {
          return import('./AssessmentActivity-D6aQXZew.js');
        },
        "./svgs/icons/Assignments.jsx": function svgsIconsAssignmentsJsx() {
          return import('./Assignments-D_AskmKv.js');
        },
        "./svgs/icons/AudioSlides.jsx": function svgsIconsAudioSlidesJsx() {
          return import('./AudioSlides-CxgLvf-I.js');
        },
        "./svgs/icons/Backspace.jsx": function svgsIconsBackspaceJsx() {
          return import('./Backspace-Jh66Hdld.js');
        },
        "./svgs/icons/Bicycle.jsx": function svgsIconsBicycleJsx() {
          return import('./Bicycle-D1pUK3ij.js');
        },
        "./svgs/icons/Binocular.jsx": function svgsIconsBinocularJsx() {
          return import('./Binocular-BD1BKzdF.js');
        },
        "./svgs/icons/Blueprint.jsx": function svgsIconsBlueprintJsx() {
          return import('./Blueprint-BuMeu1Tm.js');
        },
        "./svgs/icons/Book.jsx": function svgsIconsBookJsx() {
          return import('./Book-pim1dCoK.js');
        },
        "./svgs/icons/Bookmark.jsx": function svgsIconsBookmarkJsx() {
          return import('./Bookmark-CDBJfUlp.js');
        },
        "./svgs/icons/BookmarkOff.jsx": function svgsIconsBookmarkOffJsx() {
          return import('./BookmarkOff-BoC2Xs-0.js');
        },
        "./svgs/icons/BookmarkOn.jsx": function svgsIconsBookmarkOnJsx() {
          return import('./BookmarkOn-2WcTZ2L9.js');
        },
        "./svgs/icons/Books.jsx": function svgsIconsBooksJsx() {
          return import('./Books-Cx5wCZ6W.js');
        },
        "./svgs/icons/Box.jsx": function svgsIconsBoxJsx() {
          return import('./Box-BzuAMeay.js');
        },
        "./svgs/icons/BubbleChart.jsx": function svgsIconsBubbleChartJsx() {
          return import('./BubbleChart-D6EE9Nl8.js');
        },
        "./svgs/icons/Bullseye.jsx": function svgsIconsBullseyeJsx() {
          return import('./Bullseye-B1sj1fjH.js');
        },
        "./svgs/icons/BusinessMan.jsx": function svgsIconsBusinessManJsx() {
          return import('./BusinessMan-DGjFF35L.js');
        },
        "./svgs/icons/BusinessPhone.jsx": function svgsIconsBusinessPhoneJsx() {
          return import('./BusinessPhone-CIJMHM9G.js');
        },
        "./svgs/icons/Calculator.jsx": function svgsIconsCalculatorJsx() {
          return import('./Calculator-eIvRCjNC.js');
        },
        "./svgs/icons/Calendar.jsx": function svgsIconsCalendarJsx() {
          return import('./Calendar-D1sQp3xK.js');
        },
        "./svgs/icons/CalendarEmpty.jsx": function svgsIconsCalendarEmptyJsx() {
          return import('./CalendarEmpty-D9CPqKN0.js');
        },
        "./svgs/icons/CalendarNotAvailable.jsx": function svgsIconsCalendarNotAvailableJsx() {
          return import('./CalendarNotAvailable-dubihdZU.js');
        },
        "./svgs/icons/CallCenter.jsx": function svgsIconsCallCenterJsx() {
          return import('./CallCenter-CB9lFvUZ.js');
        },
        "./svgs/icons/Camera.jsx": function svgsIconsCameraJsx() {
          return import('./Camera-BmtRhs6m.js');
        },
        "./svgs/icons/CameraFilm.jsx": function svgsIconsCameraFilmJsx() {
          return import('./CameraFilm-BBvKx4kq.js');
        },
        "./svgs/icons/CardCollapse.jsx": function svgsIconsCardCollapseJsx() {
          return import('./CardCollapse-C0QIWSmR.js');
        },
        "./svgs/icons/CardExpand.jsx": function svgsIconsCardExpandJsx() {
          return import('./CardExpand-BRGhZXUr.js');
        },
        "./svgs/icons/Carrot.jsx": function svgsIconsCarrotJsx() {
          return import('./Carrot-BiZEF1pj.js');
        },
        "./svgs/icons/CaseStudy.jsx": function svgsIconsCaseStudyJsx() {
          return import('./CaseStudy-DcuUzizg.js');
        },
        "./svgs/icons/Caution.jsx": function svgsIconsCautionJsx() {
          return import('./Caution-DUREYpRC.js');
        },
        "./svgs/icons/Cell.jsx": function svgsIconsCellJsx() {
          return import('./Cell-BOa2qjql.js');
        },
        "./svgs/icons/CellObject.jsx": function svgsIconsCellObjectJsx() {
          return import('./CellObject-CysjjZSj.js');
        },
        "./svgs/icons/CellProcess.jsx": function svgsIconsCellProcessJsx() {
          return import('./CellProcess-DYfrJjDp.js');
        },
        "./svgs/icons/ChargeBattery.jsx": function svgsIconsChargeBatteryJsx() {
          return import('./ChargeBattery-p1CxHead.js');
        },
        "./svgs/icons/CheckClipboard.jsx": function svgsIconsCheckClipboardJsx() {
          return import('./CheckClipboard-D_8t9Wpj.js');
        },
        "./svgs/icons/Checkmark.jsx": function svgsIconsCheckmarkJsx() {
          return import('./Checkmark-BZ6xZ0os.js');
        },
        "./svgs/icons/ChevronDown.jsx": function svgsIconsChevronDownJsx() {
          return import('./ChevronDown-BQKwag2_.js');
        },
        "./svgs/icons/ChevronLeft.jsx": function svgsIconsChevronLeftJsx() {
          return import('./ChevronLeft-ki8wWgIR.js');
        },
        "./svgs/icons/ChevronRight.jsx": function svgsIconsChevronRightJsx() {
          return import('./ChevronRight-BwMT2R7B.js');
        },
        "./svgs/icons/ChevronUp.jsx": function svgsIconsChevronUpJsx() {
          return import('./ChevronUp-BfuXIjsi.js');
        },
        "./svgs/icons/Circle.jsx": function svgsIconsCircleJsx() {
          return import('./Circle-DXTRuf5u.js');
        },
        "./svgs/icons/CircleMapView.jsx": function svgsIconsCircleMapViewJsx() {
          return import('./CircleMapView-VFvKA9BA.js');
        },
        "./svgs/icons/Citatonbench.jsx": function svgsIconsCitatonbenchJsx() {
          return import('./Citatonbench-avsLAhe9.js');
        },
        "./svgs/icons/ClinicalTrial.jsx": function svgsIconsClinicalTrialJsx() {
          return import('./ClinicalTrial-CKSBK_B8.js');
        },
        "./svgs/icons/Clock.jsx": function svgsIconsClockJsx() {
          return import('./Clock-BhCdZH5A.js');
        },
        "./svgs/icons/Clockwise.jsx": function svgsIconsClockwiseJsx() {
          return import('./Clockwise-Bk8w3h3h.js');
        },
        "./svgs/icons/Close.jsx": function svgsIconsCloseJsx() {
          return import('./Close-UTqBQsMH.js');
        },
        "./svgs/icons/CloseQuotes.jsx": function svgsIconsCloseQuotesJsx() {
          return import('./CloseQuotes-BN8-XonG.js');
        },
        "./svgs/icons/Cloud.jsx": function svgsIconsCloudJsx() {
          return import('./Cloud-BjDEHMlI.js');
        },
        "./svgs/icons/CloudDownload.jsx": function svgsIconsCloudDownloadJsx() {
          return import('./CloudDownload-BzCDsbrm.js');
        },
        "./svgs/icons/CloudUpload.jsx": function svgsIconsCloudUploadJsx() {
          return import('./CloudUpload-KM9xEZhl.js');
        },
        "./svgs/icons/Clouds.jsx": function svgsIconsCloudsJsx() {
          return import('./Clouds-6oM-50p4.js');
        },
        "./svgs/icons/Coffee.jsx": function svgsIconsCoffeeJsx() {
          return import('./Coffee-CtrokbC-.js');
        },
        "./svgs/icons/CoffeeBean.jsx": function svgsIconsCoffeeBeanJsx() {
          return import('./CoffeeBean-BQmJLJWH.js');
        },
        "./svgs/icons/CoffeeNotAvailable.jsx": function svgsIconsCoffeeNotAvailableJsx() {
          return import('./CoffeeNotAvailable-DoZVGQhh.js');
        },
        "./svgs/icons/Colander.jsx": function svgsIconsColanderJsx() {
          return import('./Colander-D2vN3mRP.js');
        },
        "./svgs/icons/Collapse.jsx": function svgsIconsCollapseJsx() {
          return import('./Collapse-C9GypNNv.js');
        },
        "./svgs/icons/ColumnLeft.jsx": function svgsIconsColumnLeftJsx() {
          return import('./ColumnLeft-7KKnpA8X.js');
        },
        "./svgs/icons/ColumnMiddle.jsx": function svgsIconsColumnMiddleJsx() {
          return import('./ColumnMiddle-Ca5y2Xnr.js');
        },
        "./svgs/icons/ColumnRight.jsx": function svgsIconsColumnRightJsx() {
          return import('./ColumnRight-CBujOi-L.js');
        },
        "./svgs/icons/Columns.jsx": function svgsIconsColumnsJsx() {
          return import('./Columns-CXCGVJjt.js');
        },
        "./svgs/icons/Comb.jsx": function svgsIconsCombJsx() {
          return import('./Comb-DHNqkb9i.js');
        },
        "./svgs/icons/Comment.jsx": function svgsIconsCommentJsx() {
          return import('./Comment-D7iB72BE.js');
        },
        "./svgs/icons/CompareSavedVersions.jsx": function svgsIconsCompareSavedVersionsJsx() {
          return import('./CompareSavedVersions-hsKULcQJ.js');
        },
        "./svgs/icons/Compass.jsx": function svgsIconsCompassJsx() {
          return import('./Compass-mkyTlbM4.js');
        },
        "./svgs/icons/Computer.jsx": function svgsIconsComputerJsx() {
          return import('./Computer-C4qM5bB1.js');
        },
        "./svgs/icons/ComputerMouse.jsx": function svgsIconsComputerMouseJsx() {
          return import('./ComputerMouse-DcaEyzfi.js');
        },
        "./svgs/icons/ConfirmationOutlineCircle.jsx": function svgsIconsConfirmationOutlineCircleJsx() {
          return import('./ConfirmationOutlineCircle-DuIkzLzO.js');
        },
        "./svgs/icons/ConfirmationSolidCircle.jsx": function svgsIconsConfirmationSolidCircleJsx() {
          return import('./ConfirmationSolidCircle-CxBGKVZU.js');
        },
        "./svgs/icons/Connection.jsx": function svgsIconsConnectionJsx() {
          return import('./Connection-CYo-GIM9.js');
        },
        "./svgs/icons/Contract.jsx": function svgsIconsContractJsx() {
          return import('./Contract-CwYu8em3.js');
        },
        "./svgs/icons/Countries.jsx": function svgsIconsCountriesJsx() {
          return import('./Countries-DTBZrVyh.js');
        },
        "./svgs/icons/CountriesEdit.jsx": function svgsIconsCountriesEditJsx() {
          return import('./CountriesEdit-Deh4Ormc.js');
        },
        "./svgs/icons/CountryEdit.jsx": function svgsIconsCountryEditJsx() {
          return import('./CountryEdit-rOaHpWp8.js');
        },
        "./svgs/icons/CoupleOfPeople.jsx": function svgsIconsCoupleOfPeopleJsx() {
          return import('./CoupleOfPeople-Bo22ALrD.js');
        },
        "./svgs/icons/CreateBibliography.jsx": function svgsIconsCreateBibliographyJsx() {
          return import('./CreateBibliography-_mXYBtAw.js');
        },
        "./svgs/icons/CreditCard.jsx": function svgsIconsCreditCardJsx() {
          return import('./CreditCard-622Ti-D6.js');
        },
        "./svgs/icons/Credits.jsx": function svgsIconsCreditsJsx() {
          return import('./Credits-DEG-aGBG.js');
        },
        "./svgs/icons/Crop.jsx": function svgsIconsCropJsx() {
          return import('./Crop-DWWyva-W.js');
        },
        "./svgs/icons/Cursor.jsx": function svgsIconsCursorJsx() {
          return import('./Cursor-DBm5h1Ux.js');
        },
        "./svgs/icons/CycleQuestion.jsx": function svgsIconsCycleQuestionJsx() {
          return import('./CycleQuestion-CEl3hQby.js');
        },
        "./svgs/icons/CycleSquare.jsx": function svgsIconsCycleSquareJsx() {
          return import('./CycleSquare-DHGC6-B-.js');
        },
        "./svgs/icons/Database.jsx": function svgsIconsDatabaseJsx() {
          return import('./Database-BSLmvSpZ.js');
        },
        "./svgs/icons/DeleteDocument.jsx": function svgsIconsDeleteDocumentJsx() {
          return import('./DeleteDocument-CI3dycOP.js');
        },
        "./svgs/icons/Directions.jsx": function svgsIconsDirectionsJsx() {
          return import('./Directions-Cv9Hw8hG.js');
        },
        "./svgs/icons/Discussion.jsx": function svgsIconsDiscussionJsx() {
          return import('./Discussion-Bpp9cL9k.js');
        },
        "./svgs/icons/Disease.jsx": function svgsIconsDiseaseJsx() {
          return import('./Disease-DVor9R5s.js');
        },
        "./svgs/icons/Doc.jsx": function svgsIconsDocJsx() {
          return import('./Doc-BQ3qy5yS.js');
        },
        "./svgs/icons/DocFile.jsx": function svgsIconsDocFileJsx() {
          return import('./DocFile-ByPz-YO8.js');
        },
        "./svgs/icons/DocumentCheck.jsx": function svgsIconsDocumentCheckJsx() {
          return import('./DocumentCheck-CKlKCRge.js');
        },
        "./svgs/icons/DocumentChecked.jsx": function svgsIconsDocumentCheckedJsx() {
          return import('./DocumentChecked-CEmsH2I8.js');
        },
        "./svgs/icons/DocumentCsv.jsx": function svgsIconsDocumentCsvJsx() {
          return import('./DocumentCsv-BT7RxPWw.js');
        },
        "./svgs/icons/DocumentNew.jsx": function svgsIconsDocumentNewJsx() {
          return import('./DocumentNew-fiSo-o9F.js');
        },
        "./svgs/icons/DocumentNotAvailable.jsx": function svgsIconsDocumentNotAvailableJsx() {
          return import('./DocumentNotAvailable-Davzd-Lj.js');
        },
        "./svgs/icons/DownLeft.jsx": function svgsIconsDownLeftJsx() {
          return import('./DownLeft-ClKd-L0q.js');
        },
        "./svgs/icons/DownRight.jsx": function svgsIconsDownRightJsx() {
          return import('./DownRight-C1mlQ1vI.js');
        },
        "./svgs/icons/Download.jsx": function svgsIconsDownloadJsx() {
          return import('./Download-C-H5Citc.js');
        },
        "./svgs/icons/Drag.jsx": function svgsIconsDragJsx() {
          return import('./Drag-BFxD30JJ.js');
        },
        "./svgs/icons/DrawStructureNew.jsx": function svgsIconsDrawStructureNewJsx() {
          return import('./DrawStructureNew-E8BSFta0.js');
        },
        "./svgs/icons/Drop.jsx": function svgsIconsDropJsx() {
          return import('./Drop-iaA4fEVR.js');
        },
        "./svgs/icons/DuplicateDocument.jsx": function svgsIconsDuplicateDocumentJsx() {
          return import('./DuplicateDocument-BS9UbN2m.js');
        },
        "./svgs/icons/DvdPlayer.jsx": function svgsIconsDvdPlayerJsx() {
          return import('./DvdPlayer-C8KOBU8G.js');
        },
        "./svgs/icons/Ebook.jsx": function svgsIconsEbookJsx() {
          return import('./Ebook-DsxsbGVC.js');
        },
        "./svgs/icons/EbookReading.jsx": function svgsIconsEbookReadingJsx() {
          return import('./EbookReading-B-ci6Vgw.js');
        },
        "./svgs/icons/Edit.jsx": function svgsIconsEditJsx() {
          return import('./Edit-tww8WspM.js');
        },
        "./svgs/icons/EducationHistory.jsx": function svgsIconsEducationHistoryJsx() {
          return import('./EducationHistory-rnKRLOS9.js');
        },
        "./svgs/icons/Eject.jsx": function svgsIconsEjectJsx() {
          return import('./Eject-C55ltu9y.js');
        },
        "./svgs/icons/Ellipsis.jsx": function svgsIconsEllipsisJsx() {
          return import('./Ellipsis-DAcskaFv.js');
        },
        "./svgs/icons/EllipsisOpen.jsx": function svgsIconsEllipsisOpenJsx() {
          return import('./EllipsisOpen-C5IIn0bU.js');
        },
        "./svgs/icons/Elsevier.jsx": function svgsIconsElsevierJsx() {
          return import('./Elsevier-O0a2QQpz.js');
        },
        "./svgs/icons/Email.jsx": function svgsIconsEmailJsx() {
          return import('./Email-_DRPqxP1.js');
        },
        "./svgs/icons/EmpoweringKnowledge.jsx": function svgsIconsEmpoweringKnowledgeJsx() {
          return import('./EmpoweringKnowledge-mX9Nndii.js');
        },
        "./svgs/icons/EmptyCart.jsx": function svgsIconsEmptyCartJsx() {
          return import('./EmptyCart-yqcM4uLf.js');
        },
        "./svgs/icons/EmtreeTaxonomyBrowser.jsx": function svgsIconsEmtreeTaxonomyBrowserJsx() {
          return import('./EmtreeTaxonomyBrowser-DsRj4pt2.js');
        },
        "./svgs/icons/Epub.jsx": function svgsIconsEpubJsx() {
          return import('./Epub-D__urnsW.js');
        },
        "./svgs/icons/Eraser.jsx": function svgsIconsEraserJsx() {
          return import('./Eraser-DC9sysFL.js');
        },
        "./svgs/icons/Exam.jsx": function svgsIconsExamJsx() {
          return import('./Exam-Dte5odFL.js');
        },
        "./svgs/icons/ExeFile.jsx": function svgsIconsExeFileJsx() {
          return import('./ExeFile-TJENID3N.js');
        },
        "./svgs/icons/Expand.jsx": function svgsIconsExpandJsx() {
          return import('./Expand-CyKGjX1m.js');
        },
        "./svgs/icons/Expand2.jsx": function svgsIconsExpand2Jsx() {
          return import('./Expand2-BtMMdO2B.js');
        },
        "./svgs/icons/ExportDocument.jsx": function svgsIconsExportDocumentJsx() {
          return import('./ExportDocument-B8kZmGNF.js');
        },
        "./svgs/icons/ExportProfileOrcid.jsx": function svgsIconsExportProfileOrcidJsx() {
          return import('./ExportProfileOrcid-BqLeipc1.js');
        },
        "./svgs/icons/EyeCare.jsx": function svgsIconsEyeCareJsx() {
          return import('./EyeCare-C-NI-Vjr.js');
        },
        "./svgs/icons/EyeNotVisible.jsx": function svgsIconsEyeNotVisibleJsx() {
          return import('./EyeNotVisible-qscR-YD_.js');
        },
        "./svgs/icons/EyeVisible.jsx": function svgsIconsEyeVisibleJsx() {
          return import('./EyeVisible-D1oThByU.js');
        },
        "./svgs/icons/Facebook.jsx": function svgsIconsFacebookJsx() {
          return import('./Facebook-CD7YgdMu.js');
        },
        "./svgs/icons/FailedOutlineCircle.jsx": function svgsIconsFailedOutlineCircleJsx() {
          return import('./FailedOutlineCircle-Bn6JnhTv.js');
        },
        "./svgs/icons/FailedOutlineSquare.jsx": function svgsIconsFailedOutlineSquareJsx() {
          return import('./FailedOutlineSquare-BLa72SKp.js');
        },
        "./svgs/icons/FailedSolidCircle.jsx": function svgsIconsFailedSolidCircleJsx() {
          return import('./FailedSolidCircle-EsvtUlIo.js');
        },
        "./svgs/icons/FailedSolidSquare.jsx": function svgsIconsFailedSolidSquareJsx() {
          return import('./FailedSolidSquare-BCQp4lyO.js');
        },
        "./svgs/icons/FastForward.jsx": function svgsIconsFastForwardJsx() {
          return import('./FastForward-D3GZxGs3.js');
        },
        "./svgs/icons/Fax.jsx": function svgsIconsFaxJsx() {
          return import('./Fax-DTtGuco3.js');
        },
        "./svgs/icons/FeedbackExcited.jsx": function svgsIconsFeedbackExcitedJsx() {
          return import('./FeedbackExcited-COWykvJs.js');
        },
        "./svgs/icons/FeedbackHappy.jsx": function svgsIconsFeedbackHappyJsx() {
          return import('./FeedbackHappy-CUQ1YVwr.js');
        },
        "./svgs/icons/FeedbackMeh.jsx": function svgsIconsFeedbackMehJsx() {
          return import('./FeedbackMeh-Dw4bmQTJ.js');
        },
        "./svgs/icons/FeedbackSad.jsx": function svgsIconsFeedbackSadJsx() {
          return import('./FeedbackSad-ClSG-p9r.js');
        },
        "./svgs/icons/FemaleFace.jsx": function svgsIconsFemaleFaceJsx() {
          return import('./FemaleFace-CCLpAHsC.js');
        },
        "./svgs/icons/File.jsx": function svgsIconsFileJsx() {
          return import('./File-Fub9rsyD.js');
        },
        "./svgs/icons/Filter.jsx": function svgsIconsFilterJsx() {
          return import('./Filter-RheyODAX.js');
        },
        "./svgs/icons/FingerPointUp.jsx": function svgsIconsFingerPointUpJsx() {
          return import('./FingerPointUp-qO8vYysI.js');
        },
        "./svgs/icons/Flag.jsx": function svgsIconsFlagJsx() {
          return import('./Flag-CxJvUg5Z.js');
        },
        "./svgs/icons/FlipTile.jsx": function svgsIconsFlipTileJsx() {
          return import('./FlipTile-BnNNLwmQ.js');
        },
        "./svgs/icons/Flowchart.jsx": function svgsIconsFlowchartJsx() {
          return import('./Flowchart-D1CpxBly.js');
        },
        "./svgs/icons/Folder.jsx": function svgsIconsFolderJsx() {
          return import('./Folder-CPnHcKzI.js');
        },
        "./svgs/icons/FolderIn.jsx": function svgsIconsFolderInJsx() {
          return import('./FolderIn-DF-NBF8z.js');
        },
        "./svgs/icons/FolderOut.jsx": function svgsIconsFolderOutJsx() {
          return import('./FolderOut-B1ZhthmS.js');
        },
        "./svgs/icons/FolderSolid.jsx": function svgsIconsFolderSolidJsx() {
          return import('./FolderSolid-CeBp_3GB.js');
        },
        "./svgs/icons/Forbidden.jsx": function svgsIconsForbiddenJsx() {
          return import('./Forbidden-DWFkA0b2.js');
        },
        "./svgs/icons/Fork.jsx": function svgsIconsForkJsx() {
          return import('./Fork-CMYtOq9S.js');
        },
        "./svgs/icons/FountainPen.jsx": function svgsIconsFountainPenJsx() {
          return import('./FountainPen-DrBgorBQ.js');
        },
        "./svgs/icons/FullyCharged.jsx": function svgsIconsFullyChargedJsx() {
          return import('./FullyCharged-DWpuyKM7.js');
        },
        "./svgs/icons/FunctionalClass.jsx": function svgsIconsFunctionalClassJsx() {
          return import('./FunctionalClass-BCGyiN1z.js');
        },
        "./svgs/icons/GifFile.jsx": function svgsIconsGifFileJsx() {
          return import('./GifFile-BrL8nZIZ.js');
        },
        "./svgs/icons/Globe.jsx": function svgsIconsGlobeJsx() {
          return import('./Globe-12oT1NfY.js');
        },
        "./svgs/icons/GooglePlay.jsx": function svgsIconsGooglePlayJsx() {
          return import('./GooglePlay-B_IFibJy.js');
        },
        "./svgs/icons/Grid.jsx": function svgsIconsGridJsx() {
          return import('./Grid-NiR-HGG2.js');
        },
        "./svgs/icons/GroupOfPeople.jsx": function svgsIconsGroupOfPeopleJsx() {
          return import('./GroupOfPeople-Bfn9VUAm.js');
        },
        "./svgs/icons/GroupOfResearchers.jsx": function svgsIconsGroupOfResearchersJsx() {
          return import('./GroupOfResearchers-BulHe6bW.js');
        },
        "./svgs/icons/Hand.jsx": function svgsIconsHandJsx() {
          return import('./Hand-BtEVAXRv.js');
        },
        "./svgs/icons/HardDrive.jsx": function svgsIconsHardDriveJsx() {
          return import('./HardDrive-BpjMQTk7.js');
        },
        "./svgs/icons/Heart.jsx": function svgsIconsHeartJsx() {
          return import('./Heart-BncLr9fw.js');
        },
        "./svgs/icons/HeartSolid.jsx": function svgsIconsHeartSolidJsx() {
          return import('./HeartSolid-ROz2Lq36.js');
        },
        "./svgs/icons/HelpOutlineCircle.jsx": function svgsIconsHelpOutlineCircleJsx() {
          return import('./HelpOutlineCircle-BXvclg5Y.js');
        },
        "./svgs/icons/HelpSolidCircle.jsx": function svgsIconsHelpSolidCircleJsx() {
          return import('./HelpSolidCircle-BbE3xPkZ.js');
        },
        "./svgs/icons/HighBattery.jsx": function svgsIconsHighBatteryJsx() {
          return import('./HighBattery-yMYjs8A3.js');
        },
        "./svgs/icons/Highlight.jsx": function svgsIconsHighlightJsx() {
          return import('./Highlight-CJRYXWt8.js');
        },
        "./svgs/icons/Home.jsx": function svgsIconsHomeJsx() {
          return import('./Home-B-04UZbO.js');
        },
        "./svgs/icons/HomeInstitution.jsx": function svgsIconsHomeInstitutionJsx() {
          return import('./HomeInstitution-Hq3iRCJD.js');
        },
        "./svgs/icons/Hospital.jsx": function svgsIconsHospitalJsx() {
          return import('./Hospital-DnyMrFnv.js');
        },
        "./svgs/icons/Hot.jsx": function svgsIconsHotJsx() {
          return import('./Hot-BCxZuEf4.js');
        },
        "./svgs/icons/HotTea.jsx": function svgsIconsHotTeaJsx() {
          return import('./HotTea-zV6vOYIJ.js');
        },
        "./svgs/icons/HyHart.jsx": function svgsIconsHyHartJsx() {
          return import('./HyHart-CG4RmdJ4.js');
        },
        "./svgs/icons/Idea.jsx": function svgsIconsIdeaJsx() {
          return import('./Idea-BK4IEIB3.js');
        },
        "./svgs/icons/InProgress.jsx": function svgsIconsInProgressJsx() {
          return import('./InProgress-DUEUMjey.js');
        },
        "./svgs/icons/Inbox.jsx": function svgsIconsInboxJsx() {
          return import('./Inbox-BatKZ-FS.js');
        },
        "./svgs/icons/InformationOutlineCircle.jsx": function svgsIconsInformationOutlineCircleJsx() {
          return import('./InformationOutlineCircle-Dz0GanaF.js');
        },
        "./svgs/icons/InformationOutlineSquare.jsx": function svgsIconsInformationOutlineSquareJsx() {
          return import('./InformationOutlineSquare-CwRRUCNz.js');
        },
        "./svgs/icons/InformationSolidCircle.jsx": function svgsIconsInformationSolidCircleJsx() {
          return import('./InformationSolidCircle-C-q7WefX.js');
        },
        "./svgs/icons/InformationSolidSquare.jsx": function svgsIconsInformationSolidSquareJsx() {
          return import('./InformationSolidSquare-Tx8HsnmS.js');
        },
        "./svgs/icons/Instagram.jsx": function svgsIconsInstagramJsx() {
          return import('./Instagram-BpSjQyv9.js');
        },
        "./svgs/icons/Institution.jsx": function svgsIconsInstitutionJsx() {
          return import('./Institution-0a_hGj6J.js');
        },
        "./svgs/icons/InstitutionEdit.jsx": function svgsIconsInstitutionEditJsx() {
          return import('./InstitutionEdit-mhaPFkDv.js');
        },
        "./svgs/icons/InstitutionRanking.jsx": function svgsIconsInstitutionRankingJsx() {
          return import('./InstitutionRanking-R9PAa8ps.js');
        },
        "./svgs/icons/Institutions.jsx": function svgsIconsInstitutionsJsx() {
          return import('./Institutions-D5as0_7v.js');
        },
        "./svgs/icons/InstitutionsEdit.jsx": function svgsIconsInstitutionsEditJsx() {
          return import('./InstitutionsEdit-BseDebXd.js');
        },
        "./svgs/icons/InteractiveCaseInsights.jsx": function svgsIconsInteractiveCaseInsightsJsx() {
          return import('./InteractiveCaseInsights-D6P61jeo.js');
        },
        "./svgs/icons/Journal.jsx": function svgsIconsJournalJsx() {
          return import('./Journal-v435BvAt.js');
        },
        "./svgs/icons/JpgFile.jsx": function svgsIconsJpgFileJsx() {
          return import('./JpgFile-DcmTpBHa.js');
        },
        "./svgs/icons/JumpToFirst.jsx": function svgsIconsJumpToFirstJsx() {
          return import('./JumpToFirst-BxsJLJfQ.js');
        },
        "./svgs/icons/JumpToLast.jsx": function svgsIconsJumpToLastJsx() {
          return import('./JumpToLast-6nUxo7TO.js');
        },
        "./svgs/icons/Key.jsx": function svgsIconsKeyJsx() {
          return import('./Key-CeU7BEBZ.js');
        },
        "./svgs/icons/LabSkills.jsx": function svgsIconsLabSkillsJsx() {
          return import('./LabSkills-DyM0qJjU.js');
        },
        "./svgs/icons/Label.jsx": function svgsIconsLabelJsx() {
          return import('./Label-CIwZAqcH.js');
        },
        "./svgs/icons/Laptop.jsx": function svgsIconsLaptopJsx() {
          return import('./Laptop-NzELxL-L.js');
        },
        "./svgs/icons/Layers.jsx": function svgsIconsLayersJsx() {
          return import('./Layers-C_AolBfK.js');
        },
        "./svgs/icons/Leaf.jsx": function svgsIconsLeafJsx() {
          return import('./Leaf-CtCTn_Zy.js');
        },
        "./svgs/icons/Lesson.jsx": function svgsIconsLessonJsx() {
          return import('./Lesson-F3EfpBxZ.js');
        },
        "./svgs/icons/LineCharts.jsx": function svgsIconsLineChartsJsx() {
          return import('./LineCharts-D4XWr20r.js');
        },
        "./svgs/icons/Link.jsx": function svgsIconsLinkJsx() {
          return import('./Link-DXuSOt5f.js');
        },
        "./svgs/icons/Linkedin.jsx": function svgsIconsLinkedinJsx() {
          return import('./Linkedin-BoEUSAwq.js');
        },
        "./svgs/icons/List.jsx": function svgsIconsListJsx() {
          return import('./List-DrbZ9zSH.js');
        },
        "./svgs/icons/Loading.jsx": function svgsIconsLoadingJsx() {
          return import('./Loading-ovjiacuk.js');
        },
        "./svgs/icons/Location.jsx": function svgsIconsLocationJsx() {
          return import('./Location-CcKw6oKL.js');
        },
        "./svgs/icons/Lock.jsx": function svgsIconsLockJsx() {
          return import('./Lock-B9N3knmg.js');
        },
        "./svgs/icons/LogIn.jsx": function svgsIconsLogInJsx() {
          return import('./LogIn-DKDVypGH.js');
        },
        "./svgs/icons/LogOut.jsx": function svgsIconsLogOutJsx() {
          return import('./LogOut-BAgaqyCG.js');
        },
        "./svgs/icons/LowBattery.jsx": function svgsIconsLowBatteryJsx() {
          return import('./LowBattery-MAkF6dW7.js');
        },
        "./svgs/icons/MaleFace.jsx": function svgsIconsMaleFaceJsx() {
          return import('./MaleFace-B9523erF.js');
        },
        "./svgs/icons/Man.jsx": function svgsIconsManJsx() {
          return import('./Man-BnFz4dTn.js');
        },
        "./svgs/icons/MapLocation.jsx": function svgsIconsMapLocationJsx() {
          return import('./MapLocation-BAR7msBK.js');
        },
        "./svgs/icons/Mastodon.jsx": function svgsIconsMastodonJsx() {
          return import('./Mastodon-CVO_5eHi.js');
        },
        "./svgs/icons/MatrixView.jsx": function svgsIconsMatrixViewJsx() {
          return import('./MatrixView-BN1gq0Lj.js');
        },
        "./svgs/icons/MeasuringCup.jsx": function svgsIconsMeasuringCupJsx() {
          return import('./MeasuringCup-BjmK6WdQ.js');
        },
        "./svgs/icons/MedicalCross.jsx": function svgsIconsMedicalCrossJsx() {
          return import('./MedicalCross-Cr2nKyws.js');
        },
        "./svgs/icons/MediumBattery.jsx": function svgsIconsMediumBatteryJsx() {
          return import('./MediumBattery-GRH99I1q.js');
        },
        "./svgs/icons/Menu.jsx": function svgsIconsMenuJsx() {
          return import('./Menu-CFKg_4KK.js');
        },
        "./svgs/icons/Merge.jsx": function svgsIconsMergeJsx() {
          return import('./Merge-DcfpgDAj.js');
        },
        "./svgs/icons/MetabolizingEnzymesTransporters.jsx": function svgsIconsMetabolizingEnzymesTransportersJsx() {
          return import('./MetabolizingEnzymesTransporters-CvznhdRR.js');
        },
        "./svgs/icons/Microphone.jsx": function svgsIconsMicrophoneJsx() {
          return import('./Microphone-nvENDk2D.js');
        },
        "./svgs/icons/Microwave.jsx": function svgsIconsMicrowaveJsx() {
          return import('./Microwave-DxWXr6-9.js');
        },
        "./svgs/icons/Minus.jsx": function svgsIconsMinusJsx() {
          return import('./Minus-M8t-FYHc.js');
        },
        "./svgs/icons/MinusCircle.jsx": function svgsIconsMinusCircleJsx() {
          return import('./MinusCircle-BUCJzo4B.js');
        },
        "./svgs/icons/MinusCircleSolid.jsx": function svgsIconsMinusCircleSolidJsx() {
          return import('./MinusCircleSolid-Beuuu2E4.js');
        },
        "./svgs/icons/MinusSolidCircle.jsx": function svgsIconsMinusSolidCircleJsx() {
          return import('./MinusSolidCircle-CM-zOPhf.js');
        },
        "./svgs/icons/MobiFile.jsx": function svgsIconsMobiFileJsx() {
          return import('./MobiFile-nPhvYL_N.js');
        },
        "./svgs/icons/MobilePhone.jsx": function svgsIconsMobilePhoneJsx() {
          return import('./MobilePhone-DCLTPpM-.js');
        },
        "./svgs/icons/Mobipocket.jsx": function svgsIconsMobipocketJsx() {
          return import('./Mobipocket-CcFjylWb.js');
        },
        "./svgs/icons/MolecularModels.jsx": function svgsIconsMolecularModelsJsx() {
          return import('./MolecularModels-DVMQLfCR.js');
        },
        "./svgs/icons/Moon.jsx": function svgsIconsMoonJsx() {
          return import('./Moon-CAWg_Hvn.js');
        },
        "./svgs/icons/Move.jsx": function svgsIconsMoveJsx() {
          return import('./Move-lbMLzEb-.js');
        },
        "./svgs/icons/MovingBox.jsx": function svgsIconsMovingBoxJsx() {
          return import('./MovingBox-CG3INw9F.js');
        },
        "./svgs/icons/MovingBoxDown.jsx": function svgsIconsMovingBoxDownJsx() {
          return import('./MovingBoxDown-BsZ8ipw_.js');
        },
        "./svgs/icons/MovingBoxUp.jsx": function svgsIconsMovingBoxUpJsx() {
          return import('./MovingBoxUp-CZxOTup7.js');
        },
        "./svgs/icons/Mp3File.jsx": function svgsIconsMp3FileJsx() {
          return import('./Mp3File-v03-HjzL.js');
        },
        "./svgs/icons/MultipleLayers.jsx": function svgsIconsMultipleLayersJsx() {
          return import('./MultipleLayers-BHfS4Etd.js');
        },
        "./svgs/icons/MusicalNote.jsx": function svgsIconsMusicalNoteJsx() {
          return import('./MusicalNote-RRg1pdGF.js');
        },
        "./svgs/icons/NavCollapse.jsx": function svgsIconsNavCollapseJsx() {
          return import('./NavCollapse-B1Md1NHH.js');
        },
        "./svgs/icons/NavExpand.jsx": function svgsIconsNavExpandJsx() {
          return import('./NavExpand-a7PZQ0DA.js');
        },
        "./svgs/icons/Navigate.jsx": function svgsIconsNavigateJsx() {
          return import('./Navigate-DRrfFa82.js');
        },
        "./svgs/icons/Needle.jsx": function svgsIconsNeedleJsx() {
          return import('./Needle-P8Dx3uaF.js');
        },
        "./svgs/icons/Neuroimagery.jsx": function svgsIconsNeuroimageryJsx() {
          return import('./Neuroimagery-BIknITzy.js');
        },
        "./svgs/icons/NeutralFace.jsx": function svgsIconsNeutralFaceJsx() {
          return import('./NeutralFace-CmIk2pcC.js');
        },
        "./svgs/icons/New.jsx": function svgsIconsNewJsx() {
          return import('./New-B0Jb1F9c.js');
        },
        "./svgs/icons/Newspaper.jsx": function svgsIconsNewspaperJsx() {
          return import('./Newspaper-pxN-el9f.js');
        },
        "./svgs/icons/NoEditing.jsx": function svgsIconsNoEditingJsx() {
          return import('./NoEditing-CfP8vJOm.js');
        },
        "./svgs/icons/NoSmoking.jsx": function svgsIconsNoSmokingJsx() {
          return import('./NoSmoking-B2FZ6wKP.js');
        },
        "./svgs/icons/NonCodingRNA.jsx": function svgsIconsNonCodingRNAJsx() {
          return import('./NonCodingRNA-ea3RR3V4.js');
        },
        "./svgs/icons/NonSolus.jsx": function svgsIconsNonSolusJsx() {
          return import('./NonSolus-D95cZA5h.js');
        },
        "./svgs/icons/NotStarted.jsx": function svgsIconsNotStartedJsx() {
          return import('./NotStarted-D9pDWlC-.js');
        },
        "./svgs/icons/Note.jsx": function svgsIconsNoteJsx() {
          return import('./Note-CsaZrUNr.js');
        },
        "./svgs/icons/Notebook.jsx": function svgsIconsNotebookJsx() {
          return import('./Notebook-BkzqtACT.js');
        },
        "./svgs/icons/NotificationsDisabled.jsx": function svgsIconsNotificationsDisabledJsx() {
          return import('./NotificationsDisabled-BoAWmSgv.js');
        },
        "./svgs/icons/OfficeBuilding.jsx": function svgsIconsOfficeBuildingJsx() {
          return import('./OfficeBuilding-BsqCzF4U.js');
        },
        "./svgs/icons/OpenBook.jsx": function svgsIconsOpenBookJsx() {
          return import('./OpenBook-BJAkgkjE.js');
        },
        "./svgs/icons/OpenFolder.jsx": function svgsIconsOpenFolderJsx() {
          return import('./OpenFolder-PGbVsKEs.js');
        },
        "./svgs/icons/OpenHandRight.jsx": function svgsIconsOpenHandRightJsx() {
          return import('./OpenHandRight-BP1kqSMI.js');
        },
        "./svgs/icons/OpenQuotes.jsx": function svgsIconsOpenQuotesJsx() {
          return import('./OpenQuotes-CZfqbavp.js');
        },
        "./svgs/icons/Orange.jsx": function svgsIconsOrangeJsx() {
          return import('./Orange-RoVeinRQ.js');
        },
        "./svgs/icons/Outbox.jsx": function svgsIconsOutboxJsx() {
          return import('./Outbox-B8JkT7Nf.js');
        },
        "./svgs/icons/Paperclip.jsx": function svgsIconsPaperclipJsx() {
          return import('./Paperclip-CQSpO7u8.js');
        },
        "./svgs/icons/Pathogen.jsx": function svgsIconsPathogenJsx() {
          return import('./Pathogen-becGe0nI.js');
        },
        "./svgs/icons/PauseHollow.jsx": function svgsIconsPauseHollowJsx() {
          return import('./PauseHollow-B3abSqj4.js');
        },
        "./svgs/icons/PauseSolid.jsx": function svgsIconsPauseSolidJsx() {
          return import('./PauseSolid-Cy5TFVxq.js');
        },
        "./svgs/icons/PdfAlternative.jsx": function svgsIconsPdfAlternativeJsx() {
          return import('./PdfAlternative-BwKQ_KjB.js');
        },
        "./svgs/icons/PdfFile.jsx": function svgsIconsPdfFileJsx() {
          return import('./PdfFile-4X7Ze9w8.js');
        },
        "./svgs/icons/Performance.jsx": function svgsIconsPerformanceJsx() {
          return import('./Performance-DyXzbVMO.js');
        },
        "./svgs/icons/PerformanceNotAvailable.jsx": function svgsIconsPerformanceNotAvailableJsx() {
          return import('./PerformanceNotAvailable-CGJ0pl5h.js');
        },
        "./svgs/icons/Person.jsx": function svgsIconsPersonJsx() {
          return import('./Person-Cu6XQIAB.js');
        },
        "./svgs/icons/Pharmacokinetic.jsx": function svgsIconsPharmacokineticJsx() {
          return import('./Pharmacokinetic-sSYfRpLF.js');
        },
        "./svgs/icons/Phone.jsx": function svgsIconsPhoneJsx() {
          return import('./Phone-CYB8vsgV.js');
        },
        "./svgs/icons/PhoneDisabled.jsx": function svgsIconsPhoneDisabledJsx() {
          return import('./PhoneDisabled-CXKCFc6-.js');
        },
        "./svgs/icons/Picture.jsx": function svgsIconsPictureJsx() {
          return import('./Picture-CPtu5CT4.js');
        },
        "./svgs/icons/PieChart.jsx": function svgsIconsPieChartJsx() {
          return import('./PieChart-DhvOfGmP.js');
        },
        "./svgs/icons/Pill.jsx": function svgsIconsPillJsx() {
          return import('./Pill--QjvFFPf.js');
        },
        "./svgs/icons/Pin.jsx": function svgsIconsPinJsx() {
          return import('./Pin-bpQFQhtr.js');
        },
        "./svgs/icons/Pixel.jsx": function svgsIconsPixelJsx() {
          return import('./Pixel-uD40Y1z2.js');
        },
        "./svgs/icons/PlayHollow.jsx": function svgsIconsPlayHollowJsx() {
          return import('./PlayHollow-BWJjx7Q4.js');
        },
        "./svgs/icons/PlaySolid.jsx": function svgsIconsPlaySolidJsx() {
          return import('./PlaySolid-CZkSXy1K.js');
        },
        "./svgs/icons/PlayVideo.jsx": function svgsIconsPlayVideoJsx() {
          return import('./PlayVideo-eeIC-12F.js');
        },
        "./svgs/icons/Plus.jsx": function svgsIconsPlusJsx() {
          return import('./Plus-D-fnD2Zc.js');
        },
        "./svgs/icons/PngFile.jsx": function svgsIconsPngFileJsx() {
          return import('./PngFile-CJd2Yhpf.js');
        },
        "./svgs/icons/PointingLeftUp.jsx": function svgsIconsPointingLeftUpJsx() {
          return import('./PointingLeftUp-CslISWUr.js');
        },
        "./svgs/icons/PointingRight.jsx": function svgsIconsPointingRightJsx() {
          return import('./PointingRight-DBtN7oif.js');
        },
        "./svgs/icons/Ppt2.jsx": function svgsIconsPpt2Jsx() {
          return import('./Ppt2-BxwBtBB_.js');
        },
        "./svgs/icons/PptFile.jsx": function svgsIconsPptFileJsx() {
          return import('./PptFile-BmVT4de1.js');
        },
        "./svgs/icons/Printer.jsx": function svgsIconsPrinterJsx() {
          return import('./Printer-C9cBZnck.js');
        },
        "./svgs/icons/Protein.jsx": function svgsIconsProteinJsx() {
          return import('./Protein-DAo5n0fW.js');
        },
        "./svgs/icons/ProteinKinase.jsx": function svgsIconsProteinKinaseJsx() {
          return import('./ProteinKinase-GBEM2DPY.js');
        },
        "./svgs/icons/ProteinLigand.jsx": function svgsIconsProteinLigandJsx() {
          return import('./ProteinLigand-D2zqXRvh.js');
        },
        "./svgs/icons/ProteinPhotophosphatase.jsx": function svgsIconsProteinPhotophosphataseJsx() {
          return import('./ProteinPhotophosphatase--oOLoSwu.js');
        },
        "./svgs/icons/ProteinReceptor.jsx": function svgsIconsProteinReceptorJsx() {
          return import('./ProteinReceptor-Cyk7mV91.js');
        },
        "./svgs/icons/ProteinTranscriptionFactor.jsx": function svgsIconsProteinTranscriptionFactorJsx() {
          return import('./ProteinTranscriptionFactor-CulQWb7o.js');
        },
        "./svgs/icons/ProteinTransporter.jsx": function svgsIconsProteinTransporterJsx() {
          return import('./ProteinTransporter-DR5Ka41G.js');
        },
        "./svgs/icons/ProteinVariations.jsx": function svgsIconsProteinVariationsJsx() {
          return import('./ProteinVariations-DFxMlGOy.js');
        },
        "./svgs/icons/PublicationSet.jsx": function svgsIconsPublicationSetJsx() {
          return import('./PublicationSet-CwhPgPau.js');
        },
        "./svgs/icons/PublicationSets.jsx": function svgsIconsPublicationSetsJsx() {
          return import('./PublicationSets-BPObDEvt.js');
        },
        "./svgs/icons/Radiology.jsx": function svgsIconsRadiologyJsx() {
          return import('./Radiology-CsqpK6ye.js');
        },
        "./svgs/icons/Rainbow.jsx": function svgsIconsRainbowJsx() {
          return import('./Rainbow-BuDvaWb5.js');
        },
        "./svgs/icons/Rainbow2.jsx": function svgsIconsRainbow2Jsx() {
          return import('./Rainbow2-CUrbmhie.js');
        },
        "./svgs/icons/RarFile.jsx": function svgsIconsRarFileJsx() {
          return import('./RarFile-7nfIM47n.js');
        },
        "./svgs/icons/Rationale.jsx": function svgsIconsRationaleJsx() {
          return import('./Rationale-CxBARBdA.js');
        },
        "./svgs/icons/Record.jsx": function svgsIconsRecordJsx() {
          return import('./Record-Dj4w6syA.js');
        },
        "./svgs/icons/Redo.jsx": function svgsIconsRedoJsx() {
          return import('./Redo-CNMxXm-I.js');
        },
        "./svgs/icons/RemoveDocument.jsx": function svgsIconsRemoveDocumentJsx() {
          return import('./RemoveDocument-pf-D76zG.js');
        },
        "./svgs/icons/Repeat.jsx": function svgsIconsRepeatJsx() {
          return import('./Repeat-B3Va8RIW.js');
        },
        "./svgs/icons/ResearchArea.jsx": function svgsIconsResearchAreaJsx() {
          return import('./ResearchArea-Dqb91tAo.js');
        },
        "./svgs/icons/ResearchAreaEdit.jsx": function svgsIconsResearchAreaEditJsx() {
          return import('./ResearchAreaEdit-DBSD93uj.js');
        },
        "./svgs/icons/ResearchAreas.jsx": function svgsIconsResearchAreasJsx() {
          return import('./ResearchAreas-BaWJm-dX.js');
        },
        "./svgs/icons/ResearchAreasEdit.jsx": function svgsIconsResearchAreasEditJsx() {
          return import('./ResearchAreasEdit-B_zsEgk-.js');
        },
        "./svgs/icons/Researcher.jsx": function svgsIconsResearcherJsx() {
          return import('./Researcher-IWAmZEVg.js');
        },
        "./svgs/icons/ResearcherProfileNeedsAction.jsx": function svgsIconsResearcherProfileNeedsActionJsx() {
          return import('./ResearcherProfileNeedsAction-D0y_rOBZ.js');
        },
        "./svgs/icons/ResearcherProfileUpdated.jsx": function svgsIconsResearcherProfileUpdatedJsx() {
          return import('./ResearcherProfileUpdated-XdAlEhnr.js');
        },
        "./svgs/icons/Retweet.jsx": function svgsIconsRetweetJsx() {
          return import('./Retweet-BESLSoq8.js');
        },
        "./svgs/icons/Rewind.jsx": function svgsIconsRewindJsx() {
          return import('./Rewind-CHRx1kEu.js');
        },
        "./svgs/icons/Rotate.jsx": function svgsIconsRotateJsx() {
          return import('./Rotate-Dv4B62QX.js');
        },
        "./svgs/icons/Rows.jsx": function svgsIconsRowsJsx() {
          return import('./Rows-CtvBg6bn.js');
        },
        "./svgs/icons/Ruler.jsx": function svgsIconsRulerJsx() {
          return import('./Ruler-yoD5idBK.js');
        },
        "./svgs/icons/RulerRotate.jsx": function svgsIconsRulerRotateJsx() {
          return import('./RulerRotate-CicQ1BYf.js');
        },
        "./svgs/icons/SaveFile.jsx": function svgsIconsSaveFileJsx() {
          return import('./SaveFile-CR2syZek.js');
        },
        "./svgs/icons/ScaleDown.jsx": function svgsIconsScaleDownJsx() {
          return import('./ScaleDown-Bs4EO2q5.js');
        },
        "./svgs/icons/ScaleUp.jsx": function svgsIconsScaleUpJsx() {
          return import('./ScaleUp-CVX1n8bN.js');
        },
        "./svgs/icons/Schedule.jsx": function svgsIconsScheduleJsx() {
          return import('./Schedule-cTJ29uj4.js');
        },
        "./svgs/icons/Search.jsx": function svgsIconsSearchJsx() {
          return import('./Search-10pgdhwF.js');
        },
        "./svgs/icons/SearchDocument.jsx": function svgsIconsSearchDocumentJsx() {
          return import('./SearchDocument-CJuvdXKm.js');
        },
        "./svgs/icons/SecondaryResult.jsx": function svgsIconsSecondaryResultJsx() {
          return import('./SecondaryResult-DhB1sNto.js');
        },
        "./svgs/icons/SelectionPanelAdd.jsx": function svgsIconsSelectionPanelAddJsx() {
          return import('./SelectionPanelAdd-_MOu4id9.js');
        },
        "./svgs/icons/SelectionPanelRemove.jsx": function svgsIconsSelectionPanelRemoveJsx() {
          return import('./SelectionPanelRemove-VY7PIPgW.js');
        },
        "./svgs/icons/Send.jsx": function svgsIconsSendJsx() {
          return import('./Send-BVQCwV3c.js');
        },
        "./svgs/icons/Settings.jsx": function svgsIconsSettingsJsx() {
          return import('./Settings-D0dh1FST.js');
        },
        "./svgs/icons/Share.jsx": function svgsIconsShareJsx() {
          return import('./Share-DV_BJW77.js');
        },
        "./svgs/icons/Share2.jsx": function svgsIconsShare2Jsx() {
          return import('./Share2-xDNpk9xU.js');
        },
        "./svgs/icons/ShoppingCart.jsx": function svgsIconsShoppingCartJsx() {
          return import('./ShoppingCart-B-MWrzNy.js');
        },
        "./svgs/icons/Shuffle.jsx": function svgsIconsShuffleJsx() {
          return import('./Shuffle-Cf5N7PVT.js');
        },
        "./svgs/icons/SimulationNursing.jsx": function svgsIconsSimulationNursingJsx() {
          return import('./SimulationNursing-nRVye1_z.js');
        },
        "./svgs/icons/SkillsChecklist.jsx": function svgsIconsSkillsChecklistJsx() {
          return import('./SkillsChecklist-MWgwxpRI.js');
        },
        "./svgs/icons/SkipBack.jsx": function svgsIconsSkipBackJsx() {
          return import('./SkipBack-C3UY_CSn.js');
        },
        "./svgs/icons/SkipForward.jsx": function svgsIconsSkipForwardJsx() {
          return import('./SkipForward-DmW4A5_k.js');
        },
        "./svgs/icons/Smartphone.jsx": function svgsIconsSmartphoneJsx() {
          return import('./Smartphone-iKo3_yd6.js');
        },
        "./svgs/icons/SortAsc.jsx": function svgsIconsSortAscJsx() {
          return import('./SortAsc-Bka2hYJ3.js');
        },
        "./svgs/icons/SortDefault.jsx": function svgsIconsSortDefaultJsx() {
          return import('./SortDefault-DDBoIhQb.js');
        },
        "./svgs/icons/SortDesc.jsx": function svgsIconsSortDescJsx() {
          return import('./SortDesc-iIqsxMCf.js');
        },
        "./svgs/icons/SoundHigh.jsx": function svgsIconsSoundHighJsx() {
          return import('./SoundHigh-BpL4FllF.js');
        },
        "./svgs/icons/SoundLow.jsx": function svgsIconsSoundLowJsx() {
          return import('./SoundLow-ByzOxcrN.js');
        },
        "./svgs/icons/SoundMedium.jsx": function svgsIconsSoundMediumJsx() {
          return import('./SoundMedium-BNM47A1W.js');
        },
        "./svgs/icons/SoundOff.jsx": function svgsIconsSoundOffJsx() {
          return import('./SoundOff-VEJXCaWH.js');
        },
        "./svgs/icons/Spinner.jsx": function svgsIconsSpinnerJsx() {
          return import('./Spinner-pkaDPrXN.js');
        },
        "./svgs/icons/Standard.jsx": function svgsIconsStandardJsx() {
          return import('./Standard-DiY03lTi.js');
        },
        "./svgs/icons/Star.jsx": function svgsIconsStarJsx() {
          return import('./Star-BoJG6_yi.js');
        },
        "./svgs/icons/StarSolid.jsx": function svgsIconsStarSolidJsx() {
          return import('./StarSolid-B5ZMNvOb.js');
        },
        "./svgs/icons/Statistics.jsx": function svgsIconsStatisticsJsx() {
          return import('./Statistics-w0SHJCIO.js');
        },
        "./svgs/icons/Stats.jsx": function svgsIconsStatsJsx() {
          return import('./Stats-C_NJqd7k.js');
        },
        "./svgs/icons/Stethoscope.jsx": function svgsIconsStethoscopeJsx() {
          return import('./Stethoscope-sfZzK-r_.js');
        },
        "./svgs/icons/Stop.jsx": function svgsIconsStopJsx() {
          return import('./Stop-BLzKHEH4.js');
        },
        "./svgs/icons/StopGesture.jsx": function svgsIconsStopGestureJsx() {
          return import('./StopGesture-BPjbehfC.js');
        },
        "./svgs/icons/Stopwatch.jsx": function svgsIconsStopwatchJsx() {
          return import('./Stopwatch-BpIczEwb.js');
        },
        "./svgs/icons/Strawberry.jsx": function svgsIconsStrawberryJsx() {
          return import('./Strawberry-XHMwS-6e.js');
        },
        "./svgs/icons/Structure.jsx": function svgsIconsStructureJsx() {
          return import('./Structure-BXQHvTlH.js');
        },
        "./svgs/icons/Study.jsx": function svgsIconsStudyJsx() {
          return import('./Study-BL5JCz-a.js');
        },
        "./svgs/icons/SubjectNameSubcategory.jsx": function svgsIconsSubjectNameSubcategoryJsx() {
          return import('./SubjectNameSubcategory-DeTtSnco.js');
        },
        "./svgs/icons/Suitcase.jsx": function svgsIconsSuitcaseJsx() {
          return import('./Suitcase-aMPTkYQv.js');
        },
        "./svgs/icons/Sun.jsx": function svgsIconsSunJsx() {
          return import('./Sun-DrmHELiO.js');
        },
        "./svgs/icons/Syllabus.jsx": function svgsIconsSyllabusJsx() {
          return import('./Syllabus-d0D7FwUn.js');
        },
        "./svgs/icons/Sync.jsx": function svgsIconsSyncJsx() {
          return import('./Sync-Q_HdKkeW.js');
        },
        "./svgs/icons/Tables.jsx": function svgsIconsTablesJsx() {
          return import('./Tables-Ba0FnFI3.js');
        },
        "./svgs/icons/Tablet.jsx": function svgsIconsTabletJsx() {
          return import('./Tablet-xmvjGBP1.js');
        },
        "./svgs/icons/TeddyBear.jsx": function svgsIconsTeddyBearJsx() {
          return import('./TeddyBear-7R9KrRFl.js');
        },
        "./svgs/icons/Temperature.jsx": function svgsIconsTemperatureJsx() {
          return import('./Temperature-BTYEDLp_.js');
        },
        "./svgs/icons/TextFile.jsx": function svgsIconsTextFileJsx() {
          return import('./TextFile-CEac8tvr.js');
        },
        "./svgs/icons/ThumbsDown.jsx": function svgsIconsThumbsDownJsx() {
          return import('./ThumbsDown-CzN6T-Tz.js');
        },
        "./svgs/icons/ThumbsUp.jsx": function svgsIconsThumbsUpJsx() {
          return import('./ThumbsUp-CreLFfid.js');
        },
        "./svgs/icons/Tornado.jsx": function svgsIconsTornadoJsx() {
          return import('./Tornado-BHXkwAK-.js');
        },
        "./svgs/icons/Trash.jsx": function svgsIconsTrashJsx() {
          return import('./Trash-CdMqTWV7.js');
        },
        "./svgs/icons/Twitter.jsx": function svgsIconsTwitterJsx() {
          return import('./Twitter-BxVgKbfS.js');
        },
        "./svgs/icons/TxtFile.jsx": function svgsIconsTxtFileJsx() {
          return import('./TxtFile-B08zXo0L.js');
        },
        "./svgs/icons/Undo.jsx": function svgsIconsUndoJsx() {
          return import('./Undo-Duv2HNRY.js');
        },
        "./svgs/icons/Unlink.jsx": function svgsIconsUnlinkJsx() {
          return import('./Unlink-CpScEXXa.js');
        },
        "./svgs/icons/Unlock.jsx": function svgsIconsUnlockJsx() {
          return import('./Unlock-BPynIu10.js');
        },
        "./svgs/icons/UpLeft.jsx": function svgsIconsUpLeftJsx() {
          return import('./UpLeft-B6q7EUF7.js');
        },
        "./svgs/icons/UpRight.jsx": function svgsIconsUpRightJsx() {
          return import('./UpRight-CTWgF6pL.js');
        },
        "./svgs/icons/Upload.jsx": function svgsIconsUploadJsx() {
          return import('./Upload-DWgFQ0CL.js');
        },
        "./svgs/icons/UpwardsLineChart.jsx": function svgsIconsUpwardsLineChartJsx() {
          return import('./UpwardsLineChart-BYKtXIxi.js');
        },
        "./svgs/icons/Usb.jsx": function svgsIconsUsbJsx() {
          return import('./Usb-BIxtmmZO.js');
        },
        "./svgs/icons/Vector.jsx": function svgsIconsVectorJsx() {
          return import('./Vector-C9zfz8kV.js');
        },
        "./svgs/icons/VideoCamera.jsx": function svgsIconsVideoCameraJsx() {
          return import('./VideoCamera-hHsevMa2.js');
        },
        "./svgs/icons/ViewAuthorDocuments.jsx": function svgsIconsViewAuthorDocumentsJsx() {
          return import('./ViewAuthorDocuments-CMe8Cscz.js');
        },
        "./svgs/icons/VirtualMicroscope.jsx": function svgsIconsVirtualMicroscopeJsx() {
          return import('./VirtualMicroscope-CrkvEA1P.js');
        },
        "./svgs/icons/Virus.jsx": function svgsIconsVirusJsx() {
          return import('./Virus-ooyki-5n.js');
        },
        "./svgs/icons/Warning.jsx": function svgsIconsWarningJsx() {
          return import('./Warning-U3U5FXRG.js');
        },
        "./svgs/icons/Webcam.jsx": function svgsIconsWebcamJsx() {
          return import('./Webcam-Bl7G2EIl.js');
        },
        "./svgs/icons/Wheelchair.jsx": function svgsIconsWheelchairJsx() {
          return import('./Wheelchair-CL1PNGIM.js');
        },
        "./svgs/icons/Woman.jsx": function svgsIconsWomanJsx() {
          return import('./Woman-Dm9lovAF.js');
        },
        "./svgs/icons/Wrench.jsx": function svgsIconsWrenchJsx() {
          return import('./Wrench-DnFnsOW8.js');
        },
        "./svgs/icons/Writing.jsx": function svgsIconsWritingJsx() {
          return import('./Writing-B9pyWezr.js');
        },
        "./svgs/icons/X.jsx": function svgsIconsXJsx() {
          return import('./X-Bcfwoiiz.js');
        },
        "./svgs/icons/XAxis.jsx": function svgsIconsXAxisJsx() {
          return import('./XAxis-C_OzmEVy.js');
        },
        "./svgs/icons/XlsFile.jsx": function svgsIconsXlsFileJsx() {
          return import('./XlsFile-lyRDre8p.js');
        },
        "./svgs/icons/YAxis.jsx": function svgsIconsYAxisJsx() {
          return import('./YAxis-B4vb2NGy.js');
        },
        "./svgs/icons/YouTube.jsx": function svgsIconsYouTubeJsx() {
          return import('./YouTube-CeS6NEbj.js');
        },
        "./svgs/icons/ZipFile.jsx": function svgsIconsZipFileJsx() {
          return import('./ZipFile-UXN3bn6n.js');
        },
        "./svgs/icons/ZoomIn.jsx": function svgsIconsZoomInJsx() {
          return import('./ZoomIn-dapKMSaA.js');
        },
        "./svgs/icons/ZoomOut.jsx": function svgsIconsZoomOutJsx() {
          return import('./ZoomOut-DanXFYxb.js');
        }
      }), "./svgs/icons/".concat(sprite, ".jsx"), 4);
    });
  }
  var Sprite = lazySvgs[sprite];
  var childElement = /* @__PURE__ */React.createElement("span", {
    id: labelId,
    className: textClasses,
    "data-testid": "icon-text"
  }, children);
  return /* @__PURE__ */React.createElement("span", _objectSpread(_objectSpread({
    className: wrapperClasses,
    id: id
  }, iconProps), {}, {
    "data-testid": "icon-wrapper"
  }), childrenIsString && isTextFirst && childElement, /* @__PURE__ */React.createElement(Suspense, {
    fallback: isDecorative ? null : /* @__PURE__ */React.createElement("span", {
      id: "fallback-placeholder",
      className: classes,
      "data-testid": "icon-fallback"
    }, placeholder)
  }, /* @__PURE__ */React.createElement(Sprite, {
    "aria-hidden": true,
    focusable: "false",
    id: spriteId,
    className: classes,
    role: "img",
    "data-testid": "icon-sprite"
  })), !isDecorative && !children && /* @__PURE__ */React.createElement("span", {
    className: "u-els-hide-visually",
    id: nameId,
    "data-testid": "icon-decorativeContent"
  }, name, description && /* @__PURE__ */React.createElement(React.Fragment, null, " - ", description)), childrenIsString && !isTextFirst && childElement);
};
Icon.displayName = "Icon";
Icon.propTypes = {
  // DEPRECATED: duplicates label and children
  a11y: shape({
    /** Provides an accessible description of the icon */
    description: string,
    /** Provides an accessible name for the icon. Throws if missing and isDecorative is false */
    name: string
  }),
  /** Label describing icon, required for a11y */
  children: node,
  /** Additional class to allow BEM naming in a view */
  className: string,
  /** Color of icon */
  color: oneOf(IconColors.getAll()),
  /** If the icon is part of a link button */
  fromLinkButton: bool,
  /** Unique ID */
  id: string,
  /** If the icon is decorative */
  isDecorative: bool,
  /** HTML order of label and icon */
  isTextFirst: bool,
  /** Visibility of text */
  isVisible: bool,
  /** String to be displayed while icon loads, and if icon load fails */
  placeholder: string,
  /** Size of sprite */
  size: oneOf(SpriteSizes.getAll()),
  /** Name of sprite for icon */
  sprite: oneOf(Object.values(SpriteNames)).isRequired,
  /** Alignment of text */
  textAlignment: oneOf(FontAlignments.getAll())
};
Icon.defaultProps = {
  a11y: {},
  children: null,
  className: "",
  color: IconColors.DEFAULT,
  fromLinkButton: false,
  id: null,
  isDecorative: false,
  isTextFirst: false,
  isVisible: false,
  placeholder: "□",
  textAlignment: FontAlignments.MIDDLE,
  size: SpriteSizes.S
};
Icon.requiredProps = {
  sprite: ValidPropTypes.STRING
};
Icon.Sprites = SpriteNames;
Icon.Sizes = SpriteSizes;
Icon.Colors = IconColors;
Icon.TextAlignment = FontAlignments;
var RawIcon = Icon;
var Icon$1 = makeErrorBoundComponent(RawIcon);
export { Icon$1 as Icon, RawIcon };
